import { lighten, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  typographyCustomStyle: {
    margin: "0px !important",
    padding: 0,
  },
  selectAccount: {
    minWidth: "120px"
  },
  slideContainer: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: "10",
    padding: "16px",
  },
  cardRoot: {
    position: "relative"
  },
  slideContent: {
    maxHeight: "90%",
    overflowY: 'auto',
  },
  slideContentBackBtn: {
    marginTop: "10px",
    position: "absolute",
    bottom: "10px",
    padding: "20px",
  },
  clickableRow: {
    cursor: "pointer",
    "&:hover": {
      boxShadow: `0.5px 0.5px 0.5px 0.5px ${theme.palette.action.disabledBackground}`,
      backgroundColor: theme.palette.type === "light" 
        ? lighten(theme.palette.primary.light,.8) 
        : lighten(theme.palette.primary.light,.1),
      color: theme.palette.type === "light" 
        ? "inherit"
        : theme.palette.grey[900]
    },
    "&:focus": {
      boxShadow: `0.5px 0.5px 0.5px 0.5px ${theme.palette.action.disabledBackground}`,
      backgroundColor: theme.palette.type === "light" 
        ? lighten(theme.palette.primary.light,.8) 
        : lighten(theme.palette.primary.light,.1),
      color: theme.palette.type === "light" 
        ? "inherit"
        : theme.palette.grey[900]
    },
    transition: theme.transitions.create("box-shadow", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeIn,
    }),
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: "5px",
    marginBottom: "8px",
  },
}));